import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { Grid, Container } from '@material-ui/core'
import { PersonTypePure, DialogPrivacy } from '../../pures'
import '../../pures/person-type/person-type.css'
import slogan from '../../../assets/logos/logo_finger_print.png'
import { LocalStorageService } from '../../../services'
const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};
const PersonTypeView = (props) => {
  const { t } = useTranslation()
  const [clientLogo, setclientLogo] = useState(null)
  useEffect(() => {
    let localStorageService = new LocalStorageService()
    let logo = localStorageService.getLocalStorageItem('clientLogo')
    if (logo) {
      setclientLogo(logo)
    }
  }, [])

  const iconTooltipStyles = {
    color: '#929292',
    fontSize: '20px',
    // marginLeft: '5px',
    padding: '5px',
    cursor: 'pointer'
  }

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open)
  const hiddeTooltip = () => setOpen(false)

  return (
    <div className='select-person-type-container' >
      <div className='select-person-type-header-layout' >
        <Grid container justify='center' alignItems='center'>
          <div className='header-regiter-person' item>
            <div className='logo-register-person'><img alt='Logo de govo.legal' className='data-logo-person-header' width='247' height='48' src={props.govoLogo} /></div>
            {clientLogo && (
              <img alt='Logo del cliente' className='data-logo-person-header' style={{ height: '80px', padding: '0px', margin: '8px' }} src={clientLogo} />
            )}
            <div className='data-akubicafirmadigital-person'><p alt='Logo de govo.legal' className='data-akubicaFirmaDigital-person-img' height='70' align='center' src={slogan} >Slogan <br /> govo.digital</p></div>
          </div>
        </Grid>
      </div>
      <div className='div-con-fondo select-person-type-contnet-layout' >
        <div style={{ height: '110% !important', display: 'flex', justifyContent: 'center', }} >

          <Container fixed className='container card-bottom user-register-container'>
            <h2 className='person-type-title' style={{ paddingTop: '100px', marginTop: '0px' }}>{t('register.welcome')}</h2>
            <div className='person-type-boldtext'>{t('register.thanksForChoosing')}</div>
            <div className='person-type-lighttext'>{t('register.toStart1')} <br></br>{t('register.toStart2')} </div>
            <Grid container justify='center' alignItems='center'>
              <Grid item lg={4} md={4} sm={5} es={6} xs={12} className='container no-border card-animation'>
                <PersonTypePure
                  id={1}
                  title={t('registration.action.individual')}
                  content={t('personTypePure.individual')}
                  {...props.fisica}
                  onSelectPersonType={props.onSelectPersonType}
                />
              </Grid>
              <Grid item lg={4} md={4} sm={5} es={6} xs={12} className='container no-border card-animation'>
                <PersonTypePure
                  id={2}
                  title={t('registration.action.corp')}
                  content={t('personTypePure.corporation')}
                  {...props.moral}
                  onSelectPersonType={props.onSelectPersonType}
                />
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
      <div className='select-person-type-footer-layout' >
        <Grid container justify='center' alignItems='center'>
          <div className='footer-register-person' item>
            <div className='footer-elements'>
              <div className='footer-textR-person'><h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2></div>
              <div className='footer-textL-person'><h2 onClick={() => { props.openModalTermsCond(true) }}>Aviso de Privacidad</h2>{/*<hr class="linkHref"/>*/}</div>
            </div>
          </div>
        </Grid>
        <DialogPrivacy
          {...props}
        />
      </div>
    </div>
  )
}

export { PersonTypeView as default }
